import React, { useState } from 'react';

export interface IStandardButtonProps {
  className?: string;
  text: string;
  isWhite?: boolean;
  isReversed?: boolean;
  noArrow?: boolean;
  onClick: Function;
  disabled?: boolean;
}

const StandardButton = ({ className, text, onClick, isWhite, isReversed, noArrow, disabled }: IStandardButtonProps) => (
  <button
        className={`btn btn-standard ${className || ''} ${isWhite ? 'white' : ''} ${isReversed ? 'reversed' : ''} ${disabled ? 'disabled' : ''
            }`}
        onClick={() => !disabled && onClick()}
  >
    <div className="btn-content">
      <span className="btn-text">{text}</span>
    </div>
    {!noArrow ? (
      <>
        <div className="btn-standard-pointer">
          <svg
            version="1.1"
            id="btn-pointer"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="10px"
            viewBox="0 0 6 24"
          >
            <path className="st0" d="M0,0h1.4L6,12L1.4,24H0V0z" />
          </svg>
        </div>
        <div className="btn-standard-chevron">
          <svg
            version="1.1"
            id="btn-chevron"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="10px"
            viewBox="0 0 8.7 24"
          >
            <path className="st0" d="M0,0h4.1l4.6,12L4.1,24H0l4.5-12L0,0z" />
          </svg>
        </div>
      </>
    ) : null}
  </button>
);

export default StandardButton;
